<template>
  <q-modal v-model="modalOrder" no-backdrop-dismiss no-esc-dismiss>
    <q-modal-layout>
      <v-header
          :title="$T('order') + ' # ' + (form.id || '') + ' - ' + (form['stock_order_status.description'] ?
                    $t(form['stock_order_status.description'].toLowerCase()) : '') + (form['stock_operation.description'] ? ' - ' + $t(form['stock_operation.description']) : '')"
          icon="find in page">
        <template slot="right">

          <v-button :label="changeStatusLabel" outline size="md" @click="changeStatus" class="q-mr-md cursor-pointer" :color="showChangeStatus ? 'red' : 'highlight' " v-if="canChangeStatus" />

          <v-button flat rounded dense color="primary"
                    icon="close"
                    :label="$T('close')"
                    :disable="form.busy"
                    @click="close"/>
        </template>
      </v-header>
      <card width="100%">

        <form v-if="mockData && user"
              class="row gutter-xs"
              @keydown="form.onKeydown($event)">


          <v-display v-model="form.created_at"
                     :label="$t('created at')"
                     :form="form"
                     path="created_at"
                     class="col-xl-3 col-md-4 col-sm-6 col-xs-12">
          </v-display>
          <v-display v-model="form.updated_at"
                     :label="$t('updated at')"
                     :form="form"
                     path="created_at"
                     class="col-xl-3 col-md-4 col-sm-6 col-xs-12">
          </v-display>

          <v-display v-model="form['lending_point_requester.description']"
                     :label="$t('lending point')"
                     :form="form"
                     path="lending-point"
                     class="col-xl-3 col-md-4 col-sm-6 col-xs-12">
          </v-display>

          <v-display v-model="form.quantity"
                     :label="$t('requested quantity')"
                     :form="form"
                     path="request-quantity"
                     class="col-xl-3 col-md-2 col-sm-6 col-xs-12">
          </v-display>

          <v-display v-model="form['lending_point_requester.full_address']"
                     :label="$t('address')"
                     :form="form"
                     type="textarea"
                     path="full_address"
                     class="col-xl-6 col-md-6 col-sm-6 col-xs-12">
          </v-display>

          <v-display
              :label="$t('order quantity')"
              :value="form.devices.length"
              path="order-quantity"
              class="col-xl-3 col-md-2 col-sm-6 col-xs-12">
          </v-display>

          <v-display v-model="form['channel.description']"
                     :label="$t('channel')"
                     :form="form"
                     path="channel"
                     class="col-xl-3 col-md-2 col-sm-6 col-xs-12">
          </v-display>

          <VStockOrderChangeStatus :form="form" v-if="showChangeStatus"/>

<template v-if="['Retail Call Center'].includes(user.role.name) && stock">
          <v-header
              class="q-mt-sm"
              :title="$T('stock')"
              icon="store">

          </v-header>
          <card width="100%">

            <form v-if="mockData && user"
                  class="row gutter-xs"
                  @keydown="form.onKeydown($event)">


              <v-display v-model="stock.available"
                         :label="$t('available')"
                         :form="stock"
                         path="available"
                         class="col-xl-3 col-md-4 col-sm-6 col-xs-12">
              </v-display>
              <v-display v-model="stock.inLending"
                         :label="$t('in lending')"
                         :form="stock"
                         path="inLending"
                         class="col-xl-3 col-md-4 col-sm-6 col-xs-12">
              </v-display>

              <v-display v-model="stock.toClean"
                         :label="$t('to clean/charge')"
                         :form="stock"
                         path="toClean"
                         class="col-xl-3 col-md-4 col-sm-6 col-xs-12">
              </v-display>

            </form>
          </card>
</template>

          <q-table v-if="lendingKitColorList.length" class="shadow-25 v-list bg-white" style="width:90vw; max-width: 100%;"
            :data.sync="lendingKitColorList" :columns="lendingKitColorColumns" row-key="id">

            <v-header slot="top" slot-scope="props" :title="$T('sku pos stock management')" icon="list"
              class="list-sku-header" />

            <q-tr slot="body" slot-scope="props" :props="props" class="cursor-pointer">
              <q-td v-for="col in props.cols" :key="col.name" :props="props">
                <q-item-main v-if="col.field === 'is_active'">
                    <q-icon v-if="col.value" size="1.5em" color="green" name="done"></q-icon>
                    <q-icon v-else color="red" size="1.5em" name="close"></q-icon>
                </q-item-main>
                <img height="100px" v-else-if="col.name == 'image' && col.value" :src="`/storage/uploads/${col.value}`" />
                <template v-else>{{ col.value }}</template>
              </q-td>
            </q-tr>
          </q-table>

          <devices-input
              v-if="!(['Pending'].includes(form['stock_order_status.description']) && ['Recolher'].includes(form['stock_operation.description'])) "
              :form="form" @onAddDevices="(devices) => form.devices = devices"></devices-input>


        </form>


        <div class="justify-center row layout-padding" v-else>
          <spinner-iqos size="60px"/>
        </div>


      </card>

      <!-- Submit Button -->

      <q-toolbar slot="footer" color="white">

        <div class="col-12 row justify-center q-mt-md group">
          <v-button
              v-if="['In Transit'].includes(form['stock_order_status.description']) && ['Retail Call Center'].includes(user.role.name)"
              outline
              :label="$T('call retailer')"
              icon="phone"
              color="negative"
              :loading="form.busy"
              class="no-shadow uppercase q-btn-iqos">
            <q-popover>
              <div class="group text-center">
                <p><strong>{{ $T('are you sure?') }}</strong></p>
                <v-button class="no-shadow capitalize" color="negative" no-caps
                          @click="callRetailer" v-close-overlay>
                  {{ $t('yes') }}
                </v-button>
                <v-button class="no-shadow capitalize" color="faded" no-caps v-close-overlay>
                  {{ $t('no') }}
                </v-button>
              </div>
            </q-popover>
            <template slot="loading">
              <q-spinner-puff class="on-left" color="white"></q-spinner-puff>
              {{ $T('calling...') | capitalize }}
            </template>
          </v-button>

          <!-- Courier - Move In Transit to Cancelled -->
          <v-button v-if="['In Transit'].includes(form['stock_order_status.description']) && 'Retail Call Center' != user.role.name"
                    outline
                    :label="$T('cancel order')"
                    icon="cancel"
                    color="negative"
                    :loading="form.busy"
                    class="no-shadow uppercase q-btn-iqos">
            <q-popover>
              <div class="group text-center">
                <p><strong>{{ $T('are you sure?') }}</strong></p>
                <v-button class="no-shadow capitalize" color="negative" no-caps
                          @click="moveTo('cancelled')" v-close-overlay>
                  {{ $t('yes') }}
                </v-button>
                <v-button class="no-shadow capitalize" color="faded" no-caps v-close-overlay>
                  {{ $t('no') }}
                </v-button>
              </div>
            </q-popover>
            <template slot="loading">
              <q-spinner-puff class="on-left" color="white"></q-spinner-puff>
              {{ $T('saving...') | capitalize }}
            </template>
          </v-button>
          <!-- Courier - Print a order -->
          <v-button
              v-if="['In Transit'].includes(form['stock_order_status.description']) && ['Entrega'].includes(form['stock_operation.description']) && 'Retail Call Center' != user.role.name"
              outline
              :label="$T('print order')"
              icon="print"
              color="primary"
              :loading="form.busy"
              class="no-shadow uppercase q-btn-iqos"
              @click="printStockOrder">

            <template slot="loading">
              <q-spinner-puff class="on-left" color="white"></q-spinner-puff>
              {{ $T('saving...') | capitalize }}
            </template>
          </v-button>

          <!-- Courier - Move Pending to In Transit -->
          <v-button v-if="'Pending' == form['stock_order_status.description'] && 'Courier' == user.role.name"
                    outline
                    :label="`${$T('move to in transit')}`"
                    icon="save"
                    color="highlight"
                    class="no-shadow uppercase q-btn-iqos"
                    :loading="form.busy"
                    @click="moveTo('in-transit')">
            <template slot="loading">
              <q-spinner-puff class="on-left" color="white"></q-spinner-puff>
              {{ $T('saving...') | capitalize }}
            </template>
          </v-button>
          <!-- Courier - Move Pending to Complete -->
          <v-button
              v-if="'In Transit' == form['stock_order_status.description'] && 'Courier' == user.role.name && 'Recolher' === form['stock_operation.description']"
              outline
              :label="$T('retrieved order - move to completed')"
              icon="save"
              color="highlight"
              class="no-shadow uppercase q-btn-iqos"
              @click="moveTo('completed')"
              :loading="form.busy">
            <template slot="loading">
              <q-spinner-puff class="on-left" color="white"></q-spinner-puff>
              {{ $T('saving...') | capitalize }}
            </template>
          </v-button>
        </div>
      </q-toolbar>
    </q-modal-layout>

  </q-modal>
</template>

<script>
import Form from 'vform'
import {mapGetters} from 'vuex'
import moment from 'moment'
import axios from 'axios'
import orderModel from '../../orderModel'
import consumerModel from '../../consumerModel'
import {
  QSpinnerPuff,
  QModal
} from 'quasar-framework'
import changeCase from 'change-case'
import DevicesInput from "./DevicesInput";
import VStockOrderChangeStatus from '../../../components/form/VStockOrderChangeStatus'
// import { Platform } from 'quasar'

export default {
  mixins: [orderModel, consumerModel],

  components: {
    VStockOrderChangeStatus,
    DevicesInput,
    QSpinnerPuff,
    QModal
  },

  props: {
    show: Boolean,
    item: {
      type: Object,
      default: {}
    },

  },

  data () {
    return {
      modalOrder: this.show,
      form: {},
      formConsumer: {},
      mockPath: 'v1/order-detail',
      action: 0,
      stockAction: 0,
      mockData: null,
      genderOptions: [
        {value: 3, label: this.$T("gender male")},
        {value: 4, label: this.$T("gender female")}
      ],
      stock: [],
      lendingKitColorList: [],
      showChangeStatus: false,      
    }
  },


  watch: {
    show (newVal) {
      this.modalOrder = newVal
    },

    item (newItem) {
      this.form = new Form(Object.assign(deepCopy(this.orderModel), newItem))
      this.formConsumer = new Form(Object.assign(deepCopy(this.consumerModel), {
        id: newItem.id,
        phone: newItem.phone,
        firstname: newItem.firstname,
        lastname: newItem.lastname,
        birthdate: newItem.birthdate,
        gender: newItem.gender,
        email: newItem.email,
        zipcode: newItem.zipcode,
        city: newItem.city,
        device: newItem.device,
        referer: newItem.referer,
        observations: newItem.observations,
        contactEmail: newItem.contactEmail
      }))
      this.getMockData()
      this.getStock()
      this.getLendingKitColors()
    }
  },

  methods: {

    async getStock () {
      await axios.get(`/api/v1/get-stock/${this.form.lending_point_id_requester}`)
          .then(({data}) => {
            this.stock = data
          })
    },

    async getLendingKitColors() {
      this.lendingKitColorList = []
      axios.get(`/api/v1/courier/stock-orders/lending-kit-colors/${this.form.id}`)
        .then(({ data }) => {
          data.map((el) => {
            this.lendingKitColorList.push({
              'lending_kit_model.description': el.lending_kit_model.description,
              'sku': el.sku,
              'description': el.description,
              'image': el.image,
              'is_active': el.is_active,
              'quantity': el.pivot.quantity
            })
          })

        })
    },

    printStockOrder () {
      window.open(`${config.appUrl}/api/v1/courier/stock-order/${this.form.id}/pdf`)
    },
    close () {
      this.action = 0
      this.stockAction = 0
      this.modalOrder = false
      this.showChangeStatus = false
      this.$emit('close')
    },

    async getMockData () {
      this.mockData = null
      const {data} = await axios.get(`${config.appUrl}/api/${this.mockPath}/form-mock-data`)
      this.mockData = data.data
    },

    makeActionDataAdjustments (action) {
      if ([1, 2, 3].includes(action)) {
        this.form.pickup_address = this.form.address
        this.form.pickup_address_2 = this.form.address_2
        this.form.pickup_zipcode = this.form.zipcode
        this.form.pickup_city = this.form.city
      }

      if ([1].includes(action)) {
        this.form.is_sold = false
      }

      if ([2, 3].includes(action)) {
        this.form.is_sold = true
      }
    },

    async moveTo (orderStatus, stockStatus = '') {
      let isValid = true;
      if (this.form.devices.length < this.form.quantity && 'Pending' == this.form['stock_order_status.description'] && 'Entrega' === this.form['stock_operation.description']) {
        await this.$q.dialog(
            {
              title: this.$T('warning'),
              message: 'A quantidade que esta a dar entrada é menor do que a quaitidade solicitada \n Deseja prosseguir?',
              ok: {
                label: this.$T('yes'),
              },
              cancel: {
                label: this.$T('no'),
              }
            }).then(await function () {
          isValid = true
        }).catch(await function () {
          isValid = false
        })
      }
      // if Not valid
      if (!isValid)
        return;

      await this.form.post(`${this.baseUrl}/stock-order/${this.form.id}/move-to/${orderStatus}/${stockStatus}`)
          .then(({data}) => {
            this.close()
            this.$emit('updated')
            let msg = data.success.message


            if ('Pending' === this.form['stock_order_status.description'] && 'Entrega' === this.form['stock_operation.description']) {
              this.$q.dialog({
                title: this.$T('success'),
                message: msg,
                preventClose: true,
                color: 'primary',
                stackButtons: true,
                ok: {
                  label: this.$T('print order'),
                },
                cancel: {
                  label: this.$T('close'),
                }
              }).then(() => {
                this.printStockOrder()
              })
            } else {
              this.$q.dialog({
                title: this.$T('success'),
                message: msg,
                preventClose: true,
                color: 'primary',
                stackButtons: true,
                ok: {
                  label: this.$T('ok'),
                },

              })
            }


          }).catch(async ({response}) => {
            let message = "";
            if (response.data.hasOwnProperty('errors')) {
              Object.values(response.data.errors).forEach((item) => {
                message += item + ", \n"

              })
            } else {
              message = "erro de comunicação. Tente novamente mais tarde"
            }

            await this.$q.dialog({
              title: this.$t(response.data.message),
              message: message,
              preventClose: true,
              color: "negative",
              ok: {
                label: this.$T("ok")
              }
            })

            this.form.busy = false
          })

    },

    callRetailer () {
      if (!this.form['lending_point_requester.phone']) {
        this.$q.dialog({
          title: this.$t('Warning'),
          message: 'Este retailer não possui um contacto telefónico atribuído, logo não é possível ser contactado.',
          preventClose: true,
          color: "negative",
          ok: {
            label: this.$T("ok")
          }
        })
        return
      }
      this.$root.$emit('soft-phone-call', {
        phoneNumber: this.form['lending_point_requester.phone'],
        agent: this.user.username
      })
    },

    changeStatus () {
      this.showChangeStatus = !this.showChangeStatus
      return this.showChangeStatus
    }



  },

  computed: {
    ...mapGetters({
      user: 'auth/user'
    }),

    changeStatusLabel() {
      return this.showChangeStatus ? this.$T('Cancel Status Change') : this.$T('Change Status')
    },

    canChangeStatus() {
      return ['Admin', 'Backoffice'].includes(this.user.role.name) 
    },

    lendingKitColorColumns() {
      return [
        {
          name: 'lending_kit_model.description',
          label: this.$T('model'),
          field: 'lending_kit_model.description',
          align: 'left',
          sortable: false,
          required: false
        },
        {
          name: 'sku',
          label: this.$T('sku code'),
          field: 'sku',
          align: 'left',
          sortable: false,
          required: false
        },
        {
          name: 'description',
          label: this.$T('sku description'),
          field: 'description',
          align: 'left',
          sortable: false,
          required: false
        },
        {
          name: 'is_active',
          label: this.$T('active / inactive'),
          field: 'is_active',
          align: 'left',
          sortable: false,
          required: false
        },
        {
          name: 'image',
          label: this.$T('image'),
          field: 'image',
          align: 'left',
          sortable: false,
          required: false
        },
        {
          name: 'quantity',
          label: this.$T('requested quantity'),
          field: 'quantity',
          align: 'left',
          sortable: false,
          required: false
        }
      ]
    },

    baseUrl () {
      return `${window.config.appUrl}/api/v1/${changeCase.paramCase(this.user.role.name)}`
    },

    startLendingAt () {
      if (!this.form.start_lending_at)
        return this.$T('not started yet')
      return moment(this.form.start_lending_at).format('DD-MM-YYYY')
    },

    endLendingAt () {
      if (!this.form.end_lending_at && !this.form.start_lending_at)
        return this.$_T(':days days after start', {days: this.mockData.lendingDays})
      else if (this.form.start_lending_at && !this.form.end_lending_at)
        return moment(this.form.start_lending_at).add(this.mockData.lendingDays, 'days')
            .format('DD-MM-YYYY') + ' - ' + this.$T('planned')
      return moment(this.form.end_lending_at).format('DD-MM-YYYY')
    },

    formatedAddress () {
      if (this.form.address)
        return this.form.address + ', ' +
            (this.form.address_2 ? this.form.address_2 + ', ' : '') +
            this.form.city + '. ' +
            this.$T('zip code') + ': ' + this.form.zipcode
      return ''
    },

    formatedPickupAddress () {
      if (this.form.pickup_address)
        return this.form.pickup_address + ', ' +
            (this.form.pickup_address_2 ? this.form.pickup_address_2 + ', ' : '') +
            this.form.pickup_city + '. ' +
            this.$T('zip code') + ': ' + this.form.pickup_zipcode
      return ''
    },

    actions () {
      let order = this.item
      let role = this.user.role.name
      let orderStatus = this.form['order_status.description']

      let actions = [{value: 0, label: this.$T('no action')}]

      // Call Center
      if (order.delivery == this.$T('yes') && role == 'Call Center' && orderStatus == 'In Lending')
        actions = actions.concat([
          {value: 1, label: `${this.$T('pick up')} <strong>&gt; ${this.$T('no sold')}</strong>`},
          {value: 2, label: `${this.$T('pick up')} <strong>&gt; ${this.$T('sold')}</strong>`}
        ])

      // Lending Point
      if (role == 'Lending Point' && orderStatus == 'In Lending')
        actions = actions.concat([
          {value: 1, label: `${this.$T('completed')} <strong>&gt; ${this.$T('no sold')}</strong>`},
          {
            value: 3,
            label: `${this.$T('completed')} <strong>&gt; ${this.$T('sold, no registration')}</strong>`
          },
          {
            value: 2,
            label: `${this.$T('completed')} <strong>&gt; ${this.$T('sold, registration')}</strong>`
          }
        ])

      return actions
    },

    stockActions () {
      let role = this.user.role.name
      let orderStatus = this.form['order_status.description']

      let actions = [{value: 0, label: this.$T('no action')}]

      if ((orderStatus == 'Pending Pickup' && role == 'Courier') ||
          (orderStatus == 'In Lending' && role == 'Lending Point'))
        actions = [
          {
            value: 0,
            stockStatus: 'to-clean',
            label: `${this.$T('lending kit')} <strong>&gt; ${this.$T('to clean/charge')}</strong>`
          },
          {
            value: 11,
            stockStatus: 'broken',
            label: `${this.$T('lending kit')} <strong>&gt; ${this.$T('broken')}</strong>`
          },
          {
            value: 12,
            stockStatus: 'lost',
            label: `${this.$T('lending kit')} <strong>&gt; ${this.$T('lost')}</strong>`
          },
          {
            value: 13,
            stockStatus: 'not-returned',
            label: `${this.$T('lending kit')} <strong>&gt; ${this.$T('not returned')}</strong>`
          }
        ]

      return actions
    },

    canRegisterConsumer () {
      return this.action == 2 && ['Call Center', 'Lending Point'].includes(this.user.role.name)
    },

    canRegisterDevice () {
      return this.action == 2 && ['Lending Point'].includes(this.user.role.name)
    },

    alreadySentToDCS () {
      return !!this.form.iqos_user_id
    },


    maxBirthDate () {
      return moment().subtract(18, 'years').format('YYYY-MM-DD\THH:mm:ss.SSSZ')
    }
  },

  created: function () {

    window.addEventListener('updateDeviceEvent', (data) => {
      this.formConsumer.device = data.detail.value;
    })
  },

  destroyed: function () {
    window.removeEventListener('updateDeviceEvent', () => {
    })
  }

}
</script>

<style>
.codentify-camera-img {
  width: 4em;
  display: block;
  margin-top: 0.5em;
}
.list-sku-header,
.list-sku-header .column-icon,
.list-sku-header .column-icon .q-icon {
  border-color: #979797 !important;
  color: #979797 !important;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/pages/courier/stock-order/_stockOrderDetail.vue